export const firebaseConfig = {
  apiKey: 'AIzaSyAIX5zpg2aZe3u4DOp8haWJSYeQ4IGijPY',
  authDomain: 'labgdtec-solar.firebaseapp.com',
  projectId: 'labgdtec-solar',
  storageBucket: 'labgdtec-solar.appspot.com',
  messagingSenderId: '43517326729',
  appId: '1:43517326729:web:40457d2fc419dff355dd58',
  measurementId: 'G-E1RJRM2MV0',
};
